import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <title>Page Not Found - ProductTrace</title>
      <meta name="description" content="The page you're looking for doesn't exist." />

      <div className="min-h-screen bg-gray-50">
        <Header />
        
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center">
            <div className="text-gray-400 text-8xl mb-8">🔍</div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Page Not Found
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              The page you're looking for doesn't exist. It might have been moved, deleted, or you entered the wrong URL.
            </p>
            
            <div className="space-y-4">
              <button
                onClick={() => navigate('/')}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
              >
                Go to Homepage
              </button>
              
              <div className="text-gray-500">
                <p>Or try searching for a product:</p>
                <div className="mt-4 max-w-md mx-auto">
                  <input
                    type="text"
                    placeholder="Search for any product..."
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        const query = (e.target as HTMLInputElement).value;
                        if (query.trim()) {
                          navigate(`/search?q=${encodeURIComponent(query)}`);
                        }
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage; 